import React, { useEffect, useState } from 'react';
import { Button } from 'components/ui/button';
import { Modal } from 'react-bootstrap-5';
import LoadingBar from '../../call_lists/import/loading_bar';
import { getPropertyCrmSync } from '../../../helpers/prospect_api';
import { type PropertyCrmSync } from 'bundles/connect/types';
import { selectEmbeddedMode } from '../../store/selectors/ui';
import { useSelector } from 'react-redux';
import { BUILDOUT_CRM_MODE, RETHINK_MODE } from '../../embedded_mode';

type PropertyCrmSyncModalExportingProps = {
  propertyCrmSync: PropertyCrmSync,
  willContact?: boolean;
  onHide: () => void,
  onSyncComplete: () => void
}

export default function PropertyCrmSyncModalExporting(
  { propertyCrmSync, willContact = false, onHide, onSyncComplete }: PropertyCrmSyncModalExportingProps
) {
  const [progress, setProgress] = useState(0);
  const embeddedMode = useSelector(selectEmbeddedMode);

  const title = () => {
    switch (embeddedMode) {
    case BUILDOUT_CRM_MODE:
      return 'Syncing Properties to CRM';
    case RETHINK_MODE:
      return 'Adding to List';
    default:
      return 'Adding to List';
    }
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      const data = await getPropertyCrmSync(propertyCrmSync.id);
      if (data.syncProgress === 100) {
        onSyncComplete();
      } else {
        setProgress(data.syncProgress);
      }
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <h5 className="mb-0">{title()}</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          We're adding records to the list.
          Feel free to close this dialog {willContact && "and we'll notify you when it's complete."}
        </div>
        <LoadingBar progress={progress} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="ghost" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
